export class CustomError extends Error {
    code: string
    constructor(msg: string, code: string){
        super(msg)
        this.code= code
    }
}